import API from '@/services'
import util from '@/functions'

const LOGIN = ({ commit, state }, request) => {
  return API.post('/oauth/token', request)
    .then(resp => {
      localStorage.setItem(
        'token_' + state.websiteConfig.id,
        resp.data.access_token
      )
      localStorage.setItem(
        'impersonate_' + state.websiteConfig.id,
        false
      )
      commit('UPDATE_LOGIN_STATUS', true)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject({
        type: err.response.data.error,
        message: err.response.data.message
      })
    })
}

const RESET_PASSWORD = ({ commit }, request) => {
  return API.post('/password/reset', request)
    .then(resp => {
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const RESET_EXPIRED_PASSWORD = ({ commit }, request) => {
  return API.postAuthenticated('/password/expired', request)
    .then(resp => {
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const SEND_FORGOT_PASSWORD = ({ commit }, request) => {
  return API.post('/password/email', request)
    .then(resp => {
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOGOUT = ({ commit, state }, router) => {
  return API.getAuthenticated('/logout')
    .then(resp => {
      util.logoutFromBrowser(commit, router, state.websiteConfig.id)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PARTICIPANT = ({ commit, state }, router) => {
  return API.getAuthenticated('/me')
    .then(resp => {
      commit('UPDATE_PARTICIPANT', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      util.logoutFromBrowser(commit, router, state.websiteConfig.id)
      return Promise.reject(err)
    })
}

const LOAD_DASHBOARD = ({ commit, state }) => {
  return API.getAuthenticated('/dashboard')
    .then(resp => {
      commit('UPDATE_DASHBOARD', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PROGRAMS = ({ commit, state }) => {
  return API.getAuthenticated('/programs')
    .then(resp => {
      commit('UPDATE_PROGRAMS', resp.data.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PROGRAM = ({ commit, state }, id) => {
  return API.getAuthenticated('/programs/' + id)
    .then(resp => {
      commit('UPDATE_PROGRAM_DETAILS', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PROGRAM_DASHBOARD = ({ commit, state }, id) => {
  return API.getAuthenticated('/program-dashboard/' + id)
    .then(resp => {
      commit('UPDATE_PROGRAM_DASHBOARD', resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PAGE = ({ commit, state }, id) => {
  return API.getWithOptionalAuthentication('/pages/' + id)
    .then(resp => {
      commit('UPDATE_PAGE_DETAILS', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PLATFORM_POINT_CAP = ({ commit, state }) => {
  let participantId = state.participant.id
  return API.getWithOptionalAuthentication('/point-cap/' + participantId)
    .then(resp => {
      commit('UPDATE_PLATFORM_POINT_CAP_DETAILS', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_CARD = ({ commit, state }, {id, query}) => {
  return API.getAuthenticated('/cards/' + id + '?' + query)
    .then(resp => {
      resp.data.cardLoaded = true
      commit('UPDATE_CARD_DETAILS', resp.data)
      switch (resp.data.type) {
        case 'claims-approver':
          commit('UPDATE_APPROVER_CLAIMS', resp.data.claims)
          break
        case 'claims-submitter':
          commit('UPDATE_SUBMITTER_CLAIMS', resp.data.claims)
          break
        case 'leaderboard':
        case 'report':
          commit('UPDATE_REPORT_DATA', resp.data)
          break
        case 'chart':
          commit('UPDATE_CHART_DATA', resp.data)
          break
        default:
          break
      }
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_POINTS_LEDGER = ({ commit, state }, request) => {
  let query = new URLSearchParams(request)
  return API.getAuthenticated('/points?' + query)
    .then(resp => {
      commit('UPDATE_POINTS', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const GET_REWARD_FILTERS = ({ commit, state }, request) => {
  return API.getAuthenticated('/rewards/filters', { params: request })
    .then(resp => {
      commit('UPDATE_REWARD_FILTERS', resp.data)
      return Promise.resolve()
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

const GET_CATEGORIES = ({ commit, state }, request) => {
  let query = new URLSearchParams(request)
  return API.getAuthenticated('/rewards/categories?' + query)
    .then(resp => {
      commit('UPDATE_CATEGORIES', resp.data.categories)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const GET_REWARDS = ({ commit, state }, request) => {
  return API.getAuthenticated('/rewards', { params: request })
    .then(response => {
      commit('UPDATE_REWARDS', response.data)
      return Promise.resolve()
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

const GET_REWARD = ({ commit, state }, id) => {
  return API.getAuthenticated('/rewards/' + id)
    .then(resp => {
      commit('UPDATE_PRODUCT_DETAIL', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_PARTICIPANT_BY_TOKEN = ({ commit, state }, inviteToken) => {
  return API.getAuthenticated('/participants/invite/' + inviteToken)
    .then(resp => {
      commit('UPDATE_PARTICIPANT_SETUP', resp.data)
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const UPDATE_WEBSITE_LANG = ({ commit, state }, paxId) => {
  const url = `website-config-lang/${state.websiteConfig.id}?pax_id=${paxId}`
  return API.getWithOptionalAuthentication(url)
    .then(({ data }) => {
      util.addPlatformLanguage(data)
      commit('UPDATE_WEBSITE_CONFIG', {
        ...state.websiteConfig,
        language: {
          ...state.websiteConfig.language,
          ...data
        }
      })
    })
}

const SEND_ACCOUNT_SETUP = ({ commit }, request) => {
  return API.post('/participants/setup', request)
    .then(resp => {
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const SIGN_UP = ({ commit }, request) => {
  return API.post('/participants/signup', request)
    .then(resp => {
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const GET_WEBSITE_CONFIG = ({ commit, state }, router) => {
  const browserLang = window.navigator.language
  return API.get('website-config?url=' + encodeURIComponent(window.location.href) + '&lang=' + browserLang + '&prefix=signup')
    .then(response => {
      util.addPlatformLanguage(response.data.websiteConfig.language)
      commit('UPDATE_WEBSITE_CONFIG', response.data.websiteConfig)
      return Promise.resolve(response)
    })
    .catch(error => Promise.reject(error))
}

const WEBSITE_CONFIG_AUTH_UPDATE = ({ commit, state }, router) => {
  let url = `website-config-auth/${state.websiteConfig.id}?include_fields=1`
  return API.getWithOptionalAuthentication(url)
    .then(resp => {
      let websiteConfig = state.websiteConfig

      websiteConfig.nav_footer = resp.data.websiteConfigAuth.nav_footer
      websiteConfig.left_nav_menu = resp.data.websiteConfigAuth.left_nav_menu
      websiteConfig.language = {...resp.data.websiteConfigAuth.language, ...(resp.data.websiteConfigAuth.fields || {})}
      websiteConfig.metadata = resp.data.websiteConfigAuth.metadata
      websiteConfig.profile = resp.data.websiteConfigAuth.profile
      websiteConfig.custom_platform_css_file = resp.data.websiteConfigAuth.custom_platform_css_file
      websiteConfig.custom_program_css_files = resp.data.websiteConfigAuth.custom_program_css_files
      websiteConfig.platform_images = resp.data.websiteConfigAuth.platform_images || websiteConfig.platform_images

      util.removePlatformSpecificHeaderElements()
      util.addImageLinksForMobile(websiteConfig.platform_images)

      if (resp.data.websiteConfigAuth.participant) {
        commit('UPDATE_PARTICIPANT', resp.data.websiteConfigAuth.participant)
      }
      commit('UPDATE_PROGRAM_IMAGES', resp.data.websiteConfigAuth.program_images)
      commit('UPDATE_WEBSITE_CONFIG', websiteConfig)

      var isVanityUrl = window.location.hostname !== process.env.PLATFORM_HOST
      var customRoutes = resp.data.websiteConfigAuth.pages.data
      var routes = router.options.getRoutes(isVanityUrl, customRoutes, router)

      util.addRoutes(router, routes, isVanityUrl)
      util.addPlatformLanguage(websiteConfig.language)
      util.addCustomCssFile(websiteConfig)

      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const RESEND_ACCOUNT_SETUP_EMAIL = ({ commit }, request) => {
  return API.post('/participants/resend', request)
    .then(resp => {
      return Promise.resolve(resp)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

const LOAD_APPROVER_CLAIM = ({ commit, state }, id) => {
  return API.getAuthenticated('/claims/approver/' + id)
        .then(resp => {
          commit('UPDATE_APPROVER_CLAIM', resp.data)
          return Promise.resolve()
        })
  .catch(err => {
    return Promise.reject(err)
  })
}

const LOAD_SUBMITTER_CLAIM = ({ commit, state }, id) => {
  return API.getAuthenticated('/claims/submitter/' + id)
        .then(resp => {
          commit('UPDATE_SUBMITTER_CLAIM', resp.data)
          return Promise.resolve()
        })
  .catch(err => {
    return Promise.reject(err)
  })
}

const UPDATE_SUBMITTER_CLAIM = ({ commit, state }, request) => {
  return API.postAuthenticated('/claim-forms/update/' + request.id, request.data)
        .then(resp => {
          commit('UPDATE_SUBMITTER_CLAIM', resp.data.record)
          return Promise.resolve(resp)
        })
  .catch(err => {
    return Promise.reject(err)
  })
}

const WITHDRAW_CLAIM = ({ commit, state }, id) => {
  return API.deleteAuthenticated('/claim-forms/' + id)
        .then(resp => {
          commit('WITHDRAW_CLAIM', resp.data.id)
          return Promise.resolve(resp)
        })
  .catch(err => {
    return Promise.reject(err)
  })
}

const DELETE_SAVED_REWARDS = ({ commit, state }, id) => {
  return API.deleteAuthenticated('/rewards/saved-rewards/' + id).then(resp => {
    commit('DELETE_SAVED_REWARD', id)
    commit('UPDATE_PRODUCT_SAVEDREWARD_ID', null)
    return Promise.resolve()
  }).catch(err => {
    return Promise.reject(err)
  })
}

const GET_SAVED_REWARDS = ({ commit, state }) => {
  return API.getAuthenticated('/rewards/saved-rewards').then(resp => {
    commit('UPDATE_SAVED_REWARDS', resp.data.data)
    return Promise.resolve()
  }).catch(err => {
    return Promise.reject(err)
  })
}

const ADD_SAVED_REWARD = ({ commit, state }, request) => {
  return API.postAuthenticated('/rewards/saved-rewards', request).then(resp => {
    commit('UPDATE_SAVED_REWARD', resp.data.record)
    commit('UPDATE_PRODUCT_SAVEDREWARD_ID', resp.data.record.id)
    return Promise.resolve()
  }).catch(err => {
    return Promise.reject(err)
  })
}

const LOG_EVENT = ({ commit, state }, request) => {
  return API.postAuthenticated('/events', request).then(resp => {
    return Promise.resolve(resp.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}

export {
  LOGIN,
  RESET_PASSWORD,
  RESET_EXPIRED_PASSWORD,
  SEND_FORGOT_PASSWORD,
  LOGOUT,
  LOAD_PARTICIPANT,
  LOAD_DASHBOARD,
  LOAD_PROGRAMS,
  LOAD_PROGRAM,
  LOAD_PROGRAM_DASHBOARD,
  LOAD_PAGE,
  LOAD_CARD,
  LOAD_POINTS_LEDGER,
  GET_REWARD_FILTERS,
  GET_CATEGORIES,
  GET_REWARDS,
  GET_REWARD,
  LOAD_PARTICIPANT_BY_TOKEN,
  UPDATE_WEBSITE_LANG,
  SEND_ACCOUNT_SETUP,
  GET_WEBSITE_CONFIG,
  WEBSITE_CONFIG_AUTH_UPDATE,
  LOAD_APPROVER_CLAIM,
  RESEND_ACCOUNT_SETUP_EMAIL,
  LOAD_SUBMITTER_CLAIM,
  UPDATE_SUBMITTER_CLAIM,
  WITHDRAW_CLAIM,
  SIGN_UP,
  DELETE_SAVED_REWARDS,
  GET_SAVED_REWARDS,
  ADD_SAVED_REWARD,
  LOG_EVENT,
  LOAD_PLATFORM_POINT_CAP
}



// WEBPACK FOOTER //
// ./src/store/actions.js